module.exports = ".current-one {\n  background-color: #f8fafb !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/worker/timesheets/timesheets.component.scss
// module id = ./src/app/worker/timesheets/timesheets.component.scss
// module chunks = main